// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3FoXs","filesListContainer":"PosDisputesFiles_filesListContainer__13X7g","filesButton":"PosDisputesFiles_filesButton__iv3gn"};